/**
 *
 *
 *
 *
 *
 */
import { o_util, win } from "../common/namespaces";
import type { GlobalUtils } from "../exports/index.js";
import type { OttoNexus } from "../exports/nexus.js";

export type { ApmRaw } from "../lib/apm/index.js";

/**
 *
 *
 */
export type ApmAsync = OttoNexus["apm"];

/**
 *
 */
export const apmAsync: ApmAsync = win.otto.apm;

/**
 *
 */
export type ApmSync = GlobalUtils["apm"];

/**
 *
 */
export const apmSync: ApmSync = o_util.apm;
